<template>
  <div id="app">
    <header>
      <Header />
    </header>
    <Background />
    <router-view />
    <footer>
      <Footer />
    </footer>
  </div>
</template>
<script>
import Header from "./components/Header.vue";
import Background from "./components/Background.vue";
import Footer from "./components/Footer.vue";

export default {
   components: {
    Header,
    Background,
    Footer,
  },
}
</script>
<style>
#app {
  font-family: 'Cormorant Garamond', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: rgba(0, 0, 0, 0.473);
}
</style>
